export enum Permission {
  PRESCRIBING = 'PRESCRIBING',
  PATIENT_MANAGEMENT = 'PATIENT_MANAGEMENT',
  PRESCRIPTION_MANAGEMENT = 'PRESCRIPTION_MANAGEMENT',
  USER_MANAGEMENT = 'USER_MANAGEMENT',
  BILLING_MANAGEMENT = 'BILLING_MANAGEMENT',
  ORGANIZATION_MANAGEMENT = 'ORGANIZATION_MANAGEMENT',
  LOCATION_MANAGEMENT = 'LOCATION_MANAGEMENT',
  SUPER_ADMIN_MANAGEMENT = 'SUPER_ADMIN_MANAGEMENT',
}
